// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3oUDT","row":"ProcedureTreatmentSummary_row__1iEjC"};